import React from 'react';

import NotFoundTemplate from '../templates/NotFoundTemplate';

const NotFoundPage = ({ path }) => <NotFoundTemplate path={path} />;

export default NotFoundPage;
